import { Component, OnInit } from '@angular/core';
import { MychatroomService } from './mychatroom.service';
import { ComponentFactoryResolver, ViewChild, ViewContainerRef } from '@angular/core';
import { DynamicMessageComponent } from '../../components/dynamicMessage/dynamicMessage.component';
import { AES, mode, pad, enc } from 'crypto-js';
import { CacheService } from '../../services/cache-service';
import { AuthService } from '../../services/auth.service';
import { ChatMessage } from '../../entities/chat-message.module';
import { combineLatest, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { TokenLog } from '../../entities/token-log.model';
import { WebSocketService } from '../../services/webSocketService';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-mychatroom',
  templateUrl: './mychatroom.component.html',
  styleUrls: ['./mychatroom.component.css'],
  providers: [MychatroomService]
})

export class MychatroomComponent implements OnInit {

  message: ChatMessage;
 

  learningTypeList: any;
  chatingTypeList: Observable<Array<any>>;

  userName: string;
  userId: string;

  chatingTypeCode: any = "";

  timer: any;

  domainId: string;

  userPriv: string;

  notifications: string;

  waitResponse: string = '0';

  @ViewChild('content', { read: ViewContainerRef }) content: ViewContainerRef;
  constructor(public componentFactory: ComponentFactoryResolver,
  public mychatroomService: MychatroomService,
  private authService:AuthService, private readonly router: Router,
  private webSocketService: WebSocketService,
  private userService:UserService) {

    if(this.waitResponse == '0'){
      
    // Open connection with server socket
    let stompClient = this.webSocketService.connect();
    stompClient.debug = null;
    
    stompClient.connect({}, frame => {

      this.userService.callWSConnectRestAPI({id:this.userId}).subscribe();

  // Subscribe to notification topic
        stompClient.subscribe(`/ws/user/${this.userId}/topic/notification`, notifications => {

          console.log(notifications.body);
           const rscontjson = JSON.parse(notifications.body);
            const content = rscontjson.cont;
            const debugMsg = ((rscontjson.debugMsg));
            this.createRespBlock(content, debugMsg);
        })
    });
    
  }
  }

  createRespBlock(responseMessage, debugMessage?){
    
    const respComponent = this.componentFactory.resolveComponentFactory(DynamicMessageComponent);
    const respCom = this.content.createComponent(respComponent);
    respCom.instance.userName = '佐伦';//Jacky';
    respCom.instance.inputMessage = responseMessage;
    respCom.instance.isResponse = true;
    respCom.instance.sendTime =  this.getNowTime();
    respCom.instance.debugMessage = debugMessage;
  }



  ngOnInit() {
    this.message = new ChatMessage();
    this.learningTypeList =  init_types();
    this.init_chat_types();
    this.authService.userInfo$.subscribe((userInfo)=>{
      this.userName = userInfo.userLoginId;
      this.domainId = userInfo.domainId;
      this.userId = userInfo.userId;
      this.message.userName = userInfo.currentUserName;
      this.message.userId = userInfo.userId;
      this.message.loginId = userInfo.userLoginId;
      this.message.domainId = userInfo.domainId;
      this.userPriv = userInfo.userPriv;
    });
  }


  init_chat_types(): any{
      this.chatingTypeCode = "";
      this.chatingTypeList = this.mychatroomService.loadChatingTypeList();
  }

  getNowTime(): string {
    var dd = new Date();
    var y = dd.getFullYear();
    var m = dd.getMonth();
    var d = dd.getDate();
    var h = dd.getHours(); 
    var mi = dd.getMinutes(); 
    var s = dd.getSeconds();
    var nyr = y+"-"+(m+1)+"-"+d;
    return nyr+" "+(h<10?('0'+h):(h)) + ':' + (mi<10?('0'+mi):(mi)) + ':' + (s<10?('0'+s):(s));
  }

  add(counter:number = 0): void {
    if (this.message.content.trim() === '') {
      return;
    }
    if(counter>=3){
      this.router.navigate(['/login']);
      return;
    }
    if(this.message.userId==null || this.message.userId=='null'){
      this.router.navigate(['/login']);
    }else{
      var rxSubscriber:Observable<TokenLog> =
      this.authService.checkTokenAndRefresh();

      if(rxSubscriber){
        rxSubscriber.subscribe((aa)=>{
          this.sendMsgOut();
        })
      }else{
        this.sendMsgOut();
      }
    }
  
 
  }

  sendMsgOut(){
    const component = this.componentFactory.resolveComponentFactory(DynamicMessageComponent);
    // component.inputs.push({propName: 'dd', templateName: 'ss'});
    const com = this.content.createComponent(component);
    // console.log(com.instance);
    const tm = this.getNowTime();
    com.instance.userName = "你";//this.userName;
    com.instance.inputMessage = this.enByEnXXS(this.message.content, tm);
    com.instance.inputMessage2 = '';// this.enByEnXXS(this.message.content2, tm);
    com.instance.sendTime = tm;
    // com.instance.learningType = this.message.learningType;

    this.message.dateTime = tm;
    this.message.appCode = this.chatingTypeCode;
    if(this.chatingTypeCode.startsWith("STY:")){
      this.message.keyPrefix = "chatSTORY";
    }else if(this.chatingTypeCode.startsWith("KF_")){
      this.message.keyPrefix = "chatKEFU";
    }

   this.mychatroomService.sendMessage2JackExt(this.message, this);
   
   this.message.content = '';
  }

  isUserAllow(){
    return '1'==this.userPriv? true: false; 
  }
 

  enByEnXXS(data: string, abc: string): string {
    if(3>2)
    return data;

    if(data===null) return null;
    if(data==="") return "";  
        var iv = enc.Latin1.parse('0123456789abcdef');


    let Keyxx = "24#($js!"+abc;
    var key2 = enc.Latin1.parse(Keyxx);
    let tmpAES = AES.encrypt(data, key2, {
      iv: iv,
      mode: mode.CBC,
      padding: pad.NoPadding
    });
    alert(tmpAES.toString()+":"+abc);
    return tmpAES.toString()+":"+abc;
  }

  onSelectChatingType(chatingTypeCode: any){
    // alert(learningTypeCode);
    this.chatingTypeCode = chatingTypeCode;
  }


  keyupHandler0(event: any) {
    if (event.keyCode === 13) {
      // event.target.parentNode.parentNode.parentNode.children[1].firstElementChild.focus();      
      // document.getElementById('inputmsg1').focus(); 
      this.add();
    }
  }


  keyupHandler1(event: any) {
    if(3>2)return;
    if (event.keyCode === 13) {
      let inputdata =  event.target.value;
      if (inputdata === '') {
        return;
      }
      this.add();
    }
  }


  getDatas(): void {
    this.mychatroomService.loadMyMessage(this.domainId, this);
  }

  logout(): void{
    this.authService.logout(this.userId);
    // this.router.navigate(['/login']);
  }
}
